import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, Box, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import Loading from "../../../shared/Loading";
import * as CONST from "../Constants";

const propTypes = {
  date: PropTypes.string,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      statement: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          text: PropTypes.string.isRequired,
          number: PropTypes.number.isRequired,
          question_id: PropTypes.number.isRequired,
        })
      ),
    })
  ).isRequired,
};
function RespondedTemplate({ questions, date }) {
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, []);

  return (
    <>
      {loading ? (
        <Loading message={"loading"} />
      ) : (
        <>
          <Box mb={3} color="#1a247e" p={2}>
            <Box mb={4} mt={2}>
              <Typography fontWeight={300} className="icon-text">
                <IoMdCheckmarkCircleOutline />
                {CONST.FORM_COMPLETED}
              </Typography>
            </Box>
            <FormControl>
              <ol>
                {questions.map((i, idx) => (
                  <Box key={idx} pb={2} fontWeight={600}>
                    <li>
                      {i.statement}
                      <RadioGroup aria-labelledby={i.statement} value={i.value ? i.value : ""}>
                        {i.options.map((o) => (
                          <FormControlLabel
                            key={o.id}
                            value={o.id}
                            disabled
                            control={
                              <Radio
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 25,
                                  },
                                }}
                              />
                            }
                            label={o.text}
                          />
                        ))}
                      </RadioGroup>
                    </li>
                  </Box>
                ))}
              </ol>
            </FormControl>
          </Box>
        </>
      )}
    </>
  );
}

RespondedTemplate.prototype = propTypes;
export default RespondedTemplate;
